module.exports = __webpack_public_path__ + "media/join.e9e878f2.mp3";